export default __webpack_public_path__ + "static/media/DSC_7619.9f3604b7.jpg";